export default __webpack_public_path__ + "static/media/plus.39fa1c79.svg";